import {
  Button,
  Card,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
  Typography,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { LuPencil, LuPlusCircle } from "react-icons/lu";
import ManageDeliveryBoy from "../../modal/head_office/ManageDeliveryBoy";
import toast from "react-hot-toast";
import {
  deleteServices,
  getServices,
  postServices,
  putServices,
} from "../../apiServices/apiServices";
import {
  LIST_DELIVERY_BOY_TABLE_HEAD,
  mailPattern,
  phoneNumber,
  strongPwd,
} from "../../variables/constants";
import { FaRegSquareCheck } from "react-icons/fa6";
import { MdOutlineMoreHoriz, MdPassword } from "react-icons/md";
import DeleteIcon from "../../assets/CloseOrDelete.svg";
import LoadingGif from "../../assets/loading_anim.gif";
import NoDataFound from "../../components/NoDataFound";
import { FiEye, FiEyeOff, FiSearch } from "react-icons/fi";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import ChangePasswordModal from "../../modal/ChangePasswordModal";

function HeadManageDeliveryBoy() {
  const [modal, setModal] = useState({
    add: false,
    update: false,
    change_password: false,
  });
  const [branchList, setBranchList] = useState([]);
  const [deliveryBoyList, setDeliveryBoyList] = useState([]);
  const [loading, setLoading] = useState({
    screen: false,
    btn: false,
    bottom_sheet: false,
  });
  const [fieldData, setFieldData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    subbranch: null,
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [changeFieldData, setChangeFieldData] = useState({
    role: "",
    delivery_id: "",
    new_password: "",
    confirm_password: "",
  });
  const [isValid, setIsValid] = useState({
    email: true,
    phone: true,
    password: true,
  });
  const [switchDeliveryBoy, setSwitchDeliveryBoy] = useState({
    normal: true,
    new: false,
    existing: false,
  });
  const [bottomsheetValues, setBottomsheetValues] = useState({
    branch: false,
    delivery_boy: true,
  });
  const [selectedExistingValues, setSelectedExistingValues] = useState({
    delivery_boy: null,
    sub_branch_list: [],
  });
  const [showPassword, setShowPassword] = useState({});
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const access_token = localStorage.getItem("gassol-head-branch-token");

  useEffect(() => {
    fetchSubBranchList();
    fetchDeliveryBoyList(true);
  }, []);

  const fetchSubBranchList = async () => {
    try {
      const res = await getServices(`/api/list/my/subbranch`, access_token);
      if (res.responseCode === 200) {
        setBranchList(res.responseData);
      } else {
        setBranchList([]);
      }
    } catch (error) {
      toast.error(error);
    }
  };
  const fetchDeliveryBoyList = async (load_bool) => {
    setLoading({ ...loading, screen: load_bool });
    try {
      const res = await getServices(`/api/list/my/partner`, access_token);
      setLoading({ ...loading, screen: false });

      if (res.responseCode === 200) {
        setDeliveryBoyList(res.responseData);
      } else {
        setDeliveryBoyList([]);
      }
    } catch (error) {
      setLoading({ ...loading, screen: false });
      toast.error(error);
    }
  };

  const handleopenAddModal = () => {
    setSwitchDeliveryBoy({ ...switchDeliveryBoy, normal: true, new: false });
    setModal({ ...modal, add: true });
    setIsPasswordVisible(false);
    setFieldData({
      ...fieldData,
      name: "",
      phone: "",
      email: "",
      password: "",
      subbranch: null,
    });
  };

  const handleOpenUpdateModal = (delivery_boy_data) => {
    setModal({ ...modal, update: true });
    setSwitchDeliveryBoy({ ...switchDeliveryBoy, normal: false });
    setIsPasswordVisible(false);
    setFieldData({
      ...fieldData,
      name: delivery_boy_data.name,
      phone: delivery_boy_data.phone?.slice(3),
      email: delivery_boy_data.email,
      partner_id: delivery_boy_data._id,
    });
  };

  const handleOpenChangePasswordModal = (headoffice_data) => {
    setModal({ ...modal, change_password: true });
    setIsPasswordVisible(false);
    setChangeFieldData({
      ...changeFieldData,
      delivery_id: headoffice_data._id,
      role: headoffice_data.role,
      new_password: "",
      confirm_password: "",
    });
  };

  const handleChangePasswordChange = (e) => {
    if (e.target.name === "new_password") {
      if (strongPwd.test(e.target.value)) {
        setIsValid({ ...isValid, password: true });
      } else {
        setIsValid({ ...isValid, password: false });
      }
    }
    setChangeFieldData({ ...changeFieldData, [e.target.name]: e.target.value });
  };

  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    if (!isValid.password) {
      toast.error(
        "Password must have atleast 1 lowercase, number, special characters and minimum 8 characters."
      );
      setLoading({ ...loading, btn: false });
    } else if (
      changeFieldData.confirm_password !== changeFieldData.new_password
    ) {
      toast.error("New password and confirm password should match.");
    } else {
      try {
        const res = await postServices(
          `/api/change/password`,
          {
            new_pass: changeFieldData.new_password,
            cnfm_pass: changeFieldData.confirm_password,
            id: changeFieldData.delivery_id,
            role: changeFieldData.role,
          },
          access_token
        );

        if (res.responseCode === 200) {
          setModal({ ...modal, change_password: false });
          toast.success("Password changed.");
          fetchDeliveryBoyList(false);
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "email") {
      if (mailPattern.test(e.target.value)) {
        setIsValid({ ...isValid, email: true });
      } else {
        setIsValid({ ...isValid, email: false });
      }
    } else if (e.target.name === "phone") {
      if (phoneNumber.test(e.target.value)) {
        setIsValid({ ...isValid, phone: true });
      } else {
        setIsValid({ ...isValid, phone: false });
      }
    } else if (e.target.name === "password") {
      if (strongPwd.test(e.target.value)) {
        setIsValid({ ...isValid, password: true });
      } else {
        setIsValid({ ...isValid, password: false });
      }
    }
    setFieldData({ ...fieldData, [e.target.name]: e.target.value });
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    if (!isValid.phone) {
      toast.error("Please enter a valid phone number.");
      setLoading({ ...loading, btn: false });
    } else if (!isValid.email) {
      toast.error("Please enter a valid email.");
      setLoading({ ...loading, btn: false });
    } else if (!isValid.password) {
      toast.error(
        "Password must have atleast 1 lowercase, number, special characters and minimum 8 characters."
      );
      setLoading({ ...loading, btn: false });
    } else {
      try {
        const res = await postServices(
          `/api/delivery/add`,
          {
            name: fieldData.name,
            email: fieldData.email,
            phone: "+91" + fieldData.phone,
            password: fieldData.password,
            subbranch: fieldData.subbranch?.value,
          },
          access_token
        );
        setLoading({ ...loading, btn: false });
        if (res.responseCode === 200) {
          setModal({ ...modal, add: false });
          fetchDeliveryBoyList(false);
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        setLoading({ ...loading, btn: false });
        toast.error(error);
      }
    }
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    if (!isValid.phone) {
      toast.error("Please enter a valid phone number.");
      setLoading({ ...loading, btn: false });
    } else if (!isValid.email) {
      toast.error("Please enter a valid email.");
      setLoading({ ...loading, btn: false });
    } else if (!isValid.password) {
      toast.error(
        "Password must have atleast 1 lowercase, number, special characters and minimum 8 characters."
      );
      setLoading({ ...loading, btn: false });
    } else {
      try {
        const res = await putServices(
          `/api/delivery/edit?partner_id=${fieldData.partner_id}`,
          {
            name: fieldData.name,
            email: fieldData.email,
            phone: "+91" + fieldData.phone,
          },
          access_token
        );
        setLoading({ ...loading, btn: false });
        if (res.responseCode === 200) {
          setModal({ ...modal, update: false });
          fetchDeliveryBoyList(false);
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        setLoading({ ...loading, btn: false });
        toast.error(error);
      }
    }
  };

  const handleDeleteDeliveryBoy = async (delivery_boy_data) => {
    if (window.confirm("Do you want to delete this delivery boy?")) {
      try {
        const res = await deleteServices(
          `/api/delivery/delete?partner_id=${delivery_boy_data._id}`,
          access_token
        );
        if (res.responseCode === 200) {
          fetchDeliveryBoyList(false);
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleDeliveryBoySearchChange = async (e) => {
    if (e.target.value.length > 0) {
      try {
        const res = await getServices(
          `/api/list/my/partner?searchkey=${e.target.value}`,
          access_token
        );
        if (res.responseCode === 200) {
          setDeliveryBoyList(res.responseData);
        } else {
          setDeliveryBoyList([]);
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      fetchDeliveryBoyList(false);
    }
  };

  const handleBottomBranchSearchChange = async (e) => {
    if (e.target.value.length > 0) {
      try {
        const res = await getServices(
          `/api/list/my/subbranch?searchkey=${e.target.value}`,
          access_token
        );
        if (res.responseCode === 200) {
          setBranchList(res.responseData);
        } else {
          setBranchList([]);
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      fetchSubBranchList();
    }
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const handleNewSwitchDeliveryBoy = () => {
    setSwitchDeliveryBoy({ ...switchDeliveryBoy, normal: false, new: true });
  };
  const handleExistingSwitchDeliveryBoy = () => {
    setSwitchDeliveryBoy({
      ...switchDeliveryBoy,
      normal: false,
      new: false,
      existing: true,
    });
    setModal({ ...modal, add: false });
    setBottomsheetValues({
      ...bottomsheetValues,
      branch: false,
      delivery_boy: true,
    });
  };

  const handleCheckboxChange = (event, branchId) => {
    const isChecked = event.target.checked;

    const updatedSubBranches = isChecked
      ? [...selectedExistingValues.sub_branch_list, { _id: branchId }] // Add the new branch
      : selectedExistingValues.sub_branch_list.filter(
          (subBranch) => subBranch._id !== branchId
        ); // Remove the branch by filtering it out

    setSelectedExistingValues({
      ...selectedExistingValues,
      sub_branch_list: updatedSubBranches,
    });
  };

  const handleExistingBoySubmit = async (e) => {
    e.preventDefault();
    const urlencoded = new URLSearchParams();

    for (let i = 0; i < selectedExistingValues.sub_branch_list?.length; i++) {
      urlencoded.append(
        "subbranch",
        selectedExistingValues.sub_branch_list[i]?._id
      );
    }

    if (selectedExistingValues.sub_branch_list.length > 0) {
      try {
        const res = await putServices(
          `/api/delivery/edit?partner_id=${selectedExistingValues.delivery_boy}`,
          urlencoded,
          access_token
        );
        if (res.responseCode === 200) {
          fetchDeliveryBoyList(false);
          setSwitchDeliveryBoy({
            ...switchDeliveryBoy,
            normal: false,
            new: false,
            existing: false,
          });
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      alert("Please select atleast one branch");
    }
  };

  const toggleAdminPasswordVisibility = (item_id) => {
    setShowPassword((prev) => ({
      ...prev,
      [item_id]: !prev[item_id],
    }));
  };

  return (
    <>
      <div className="px-6 pb-5 flex flex-col gap-6 pt-4 lg:pt-0">
        <div className="flex justify-between items-center gap-3">
          <p className="text-xl sm:text-2xl md:text-5xl font-bold">
            Manage Delivery Boy
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between md:items-center gap-4 md:gap-0">
          <div className="relative">
            <input
              type="text"
              className="py-4 pl-12 pr-4 outline-none rounded-xl w-full md:min-w-[280px] xl:min-w-[350px]"
              placeholder="Search by Name"
              style={{
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
              onChange={handleDeliveryBoySearchChange}
            />
            <FiSearch className="absolute top-5 left-4 text-[#BDBDBD]" />
          </div>
          <Button
            onClick={handleopenAddModal}
            className="mt-0 font-poppins bg-[#BD3B24] font-medium text-xs sm:text-sm xl:text-base rounded-xl flex items-center gap-2 px-4 sm:px-6 ml-auto outline-none"
          >
            <LuPlusCircle />
            Add
          </Button>
        </div>

        {!loading.screen ? (
          <>
            {deliveryBoyList.length > 0 ? (
              <Card
                className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidden"
                style={{
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
                }}
              >
                <table className="w-full min-w-max table-auto text-left">
                  <thead>
                    <tr>
                      {LIST_DELIVERY_BOY_TABLE_HEAD.map((head) => (
                        <th
                          key={head}
                          className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                        >
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-poppins text-white font-semibold uppercase"
                          >
                            {head}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {deliveryBoyList?.map((delivery_boy, index) => {
                      return (
                        <tr key={index}>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              <FaRegSquareCheck className="text-lg text-[#BD3B24]" />
                              {delivery_boy.name ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              {delivery_boy.phone ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold"
                            >
                              {delivery_boy.email ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              {showPassword[delivery_boy._id]
                                ? delivery_boy.password
                                : "*".repeat(delivery_boy.password?.length)}
                              {!showPassword[delivery_boy._id] ? (
                                <FiEyeOff
                                  onClick={() =>
                                    toggleAdminPasswordVisibility(
                                      delivery_boy._id
                                    )
                                  }
                                  className="cursor-pointer"
                                />
                              ) : (
                                <FiEye
                                  onClick={() =>
                                    toggleAdminPasswordVisibility(
                                      delivery_boy._id
                                    )
                                  }
                                  className="cursor-pointer"
                                />
                              )}
                            </Typography>
                          </td>
                          <td className="p-4 ">
                            {delivery_boy.subbranch?.map((sub, i) => (
                              <Typography
                                key={i}
                                variant="small"
                                color="blue-gray"
                                className="font-poppins font-semibold"
                              >
                                <li>{sub.name ?? "-"}</li>
                              </Typography>
                            ))}
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins text-xl"
                            >
                              <Menu placement="left">
                                <MenuHandler>
                                  <Button className="rounded-full p-2 bg-transparent shadow-none outline-none">
                                    <MdOutlineMoreHoriz className="text-lg text-black" />
                                  </Button>
                                </MenuHandler>
                                <MenuList className="p-0 w-fit min-w-[unset] border-0 shadow-none flex">
                                  <MenuItem
                                    className="w-fit font-poppins rounded-full py-2"
                                    onClick={() =>
                                      handleDeleteDeliveryBoy(delivery_boy)
                                    }
                                  >
                                    <img src={DeleteIcon} alt="" />
                                  </MenuItem>
                                  <MenuItem
                                    title="Update Details"
                                    className="w-fit font-poppins rounded-full"
                                    onClick={() =>
                                      handleOpenUpdateModal(delivery_boy)
                                    }
                                  >
                                    <LuPencil className="font-bold text-lg text-[#03438D]" />
                                  </MenuItem>
                                  <MenuItem
                                    title="Change Password"
                                    className="w-fit font-poppins rounded-full"
                                    onClick={() =>
                                      handleOpenChangePasswordModal(
                                        delivery_boy
                                      )
                                    }
                                  >
                                    <MdPassword className="font-bold text-lg text-[#03438D]" />
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Typography>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Card>
            ) : (
              <NoDataFound />
            )}
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>

      {/* bottom sheet for existing delivery boy */}
      <BottomSheet
        open={switchDeliveryBoy?.existing}
        className="z-[9999999] relative"
        onDismiss={() =>
          setSwitchDeliveryBoy({
            ...switchDeliveryBoy,
            normal: false,
            new: false,
            existing: false,
          })
        }
        skipInitialTransition
        defaultSnap={({ maxHeight }) => maxHeight / 2}
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 10,
          maxHeight / 4,
          maxHeight * 0.6,
        ]}
      >
        <div className="px-5 md:px-10 pb-3">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 pb-7">
            <div className="flex gap-2">
              {bottomsheetValues.branch && (
                <IoIosArrowBack
                  className="text-3xl cursor-pointer text-[#03438D]"
                  onClick={() =>
                    setBottomsheetValues({
                      ...bottomsheetValues,
                      branch: false,
                      delivery_boy: true,
                    })
                  }
                />
              )}
              <p className="font-bold text-2xl sm:text-3xl text-[#03438D]">
                Choose an{" "}
                {bottomsheetValues.branch
                  ? "Branch"
                  : bottomsheetValues.delivery_boy
                  ? "Delivery Boy"
                  : ""}
              </p>
            </div>
            {bottomsheetValues.delivery_boy ? (
              <div className="relative">
                <input
                  type="text"
                  className="py-4 pl-12 pr-4 outline-none rounded-xl w-full md:min-w-[280px] xl:min-w-[350px]"
                  placeholder="Search by Name"
                  style={{
                    boxShadow:
                      "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                  }}
                  onChange={handleDeliveryBoySearchChange}
                />
                <FiSearch className="absolute top-5 left-4 text-[#BDBDBD]" />
              </div>
            ) : (
              <div className="relative">
                <input
                  type="text"
                  className="py-4 pl-12 pr-4 outline-none rounded-xl w-full md:min-w-[280px] xl:min-w-[350px]"
                  placeholder="Search by Name"
                  style={{
                    boxShadow:
                      "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                  }}
                  onChange={handleBottomBranchSearchChange}
                />
                <FiSearch className="absolute top-5 left-4 text-[#BDBDBD]" />
              </div>
            )}
          </div>

          {bottomsheetValues.delivery_boy && (
            <>
              {deliveryBoyList.length > 0 ? (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {deliveryBoyList.map((delivery, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        setBottomsheetValues({
                          ...bottomsheetValues,
                          branch: true,
                          delivery_boy: false,
                        });
                        setSelectedExistingValues({
                          ...selectedExistingValues,
                          delivery_boy: delivery._id,
                          sub_branch_list: delivery.subbranch,
                        });
                      }}
                      className="border-none rounded-xl bg-[#03438d0f] drop-shadow-md p-4 text-[#03438D] flex justify-between items-center gap-4 cursor-pointer hover:shadow-md"
                    >
                      <p className="capitalize break-all">{delivery.name}</p>
                      <IoIosArrowForward className="text-2xl" />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center min-h-[30vh] flex flex-col justify-center items-center">
                  <p className="font-semibold text-xl sm:text-3xl">
                    Oops! No Delivery Boy Found...
                  </p>
                  <p className="text-sm mt-2 ">
                    Looks like we couldn't find any delivery boy data.
                  </p>
                </div>
              )}
            </>
          )}

          {bottomsheetValues.branch && (
            <>
              {branchList.length > 0 ? (
                <form onSubmit={handleExistingBoySubmit}>
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                    {branchList.map((branch, i) => (
                      <div
                        key={i}
                        className="border-none rounded-xl bg-[#03438d0f] drop-shadow-md p-4 text-[#03438D] flex justify-between items-center gap-4 cursor-pointer hover:shadow-md"
                      >
                        <FormControl>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedExistingValues.sub_branch_list?.some(
                                  (subBranch) => subBranch._id === branch._id
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(e, branch._id)
                                }
                                sx={{
                                  "&, &.Mui-checked": {
                                    color: "#03438D",
                                  },
                                }}
                              />
                            }
                            label={branch.name}
                            sx={{
                              ".MuiFormControlLabel-label": {
                                fontFamily: "Poppins",
                              },
                            }}
                          />
                        </FormControl>
                      </div>
                    ))}
                  </div>
                  <div className="flex justify-end items-center mt-3">
                    <Button
                      type="submit"
                      className="bg-[#03438D] tracking-widest font-poppins text-sm font-medium"
                    >
                      Continue
                    </Button>
                  </div>
                </form>
              ) : (
                <div className="text-center min-h-[30vh] flex flex-col justify-center items-center">
                  <p className="font-semibold text-xl sm:text-3xl">
                    Oops! No Branch Found...
                  </p>
                  <p className="text-sm mt-2 ">
                    Looks like we couldn't find any branch data.
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      </BottomSheet>

      <ManageDeliveryBoy
        open={modal.add}
        onClose={() => setModal({ ...modal, add: false })}
        modal={modal}
        branchList={branchList}
        setFieldData={setFieldData}
        fieldData={fieldData}
        handleChange={handleChange}
        handleAddSubmit={handleAddSubmit}
        togglePasswordVisibility={togglePasswordVisibility}
        isPasswordVisible={isPasswordVisible}
        loading={loading}
        handleNewSwitchDeliveryBoy={handleNewSwitchDeliveryBoy}
        handleExistingSwitchDeliveryBoy={handleExistingSwitchDeliveryBoy}
        switchDeliveryBoy={switchDeliveryBoy}
      />

      <ManageDeliveryBoy
        open={modal.update}
        onClose={() => setModal({ ...modal, update: false })}
        modal={modal}
        fieldData={fieldData}
        handleChange={handleChange}
        loading={loading}
        handleUpdateSubmit={handleUpdateSubmit}
        handleExistingSwitchDeliveryBoy={handleExistingSwitchDeliveryBoy}
        switchDeliveryBoy={switchDeliveryBoy}
      />

      <ChangePasswordModal
        open={modal.change_password}
        onClose={() => setModal({ ...modal, change_password: false })}
        isPasswordVisible={isPasswordVisible}
        togglePasswordVisibility={togglePasswordVisibility}
        toggleConfirmPasswordVisibility={toggleConfirmPasswordVisibility}
        handleChangePasswordChange={handleChangePasswordChange}
        handleChangePasswordSubmit={handleChangePasswordSubmit}
      />
    </>
  );
}

export default HeadManageDeliveryBoy;
